import React from "react";

export const RfmRow = (props) => {
    return (
        <>
            <tbody>
            {
                props.item.map((item, index) => {
                    return(
                        <tr className={"text-black"}>
                            <td scope="col"  >{item.rfm}</td>
                            <td scope="col"  >{item.r}</td>
                            <td scope="col"  >{item.f}</td>
                            <td scope="col"  >{item.m}</td>
                            <td scope="col"  >{item.user.name}</td>
                        </tr>
                    )
                })
            }
            </tbody>
            </>
    )
}
